// extracted by mini-css-extract-plugin
module.exports = {"bottomBackground":"AdvertiseBottomSection_bottomBackground__27SLp"};